import { useStores } from "index";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

export const ModuleDetailsPage = observer(() => {
  const { moduleDetails } = useModule();

  if (!moduleDetails) {
    return <div>Loading...</div>;
  }

  return <div>
      <h2>Title</h2>
      <p>{moduleDetails.title}</p>
      <h2>Short Description</h2>
      <p>{moduleDetails.shortDescription}</p>
      <h2>Full Description</h2>
      <p>{moduleDetails.fullDescription}</p>
      <h2>Image</h2>
      <img src={moduleDetails.imageUrl} alt={moduleDetails.title || ""} />
      <h2>Certifications</h2>
      <ul>
        {moduleDetails.certificationTests.map(cert => (
          <li key={cert.id}>
            <h3>{cert.title}</h3>
            <p>{cert.description}</p>
            <p>Duration: {cert.durationInMinutes} minutes</p>
            <h4>Prerequisites:</h4>
            <ul>
              {cert.prerequisites.map(pr => (
                <li key={pr.id}>{pr.title}</li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>;
});

const useModule = () => {
  const { moduleId } = useParams<{ moduleId: string }>();
  const { modulesStore } = useStores();

  useEffect(() => {
    if (moduleId) {
      modulesStore.getModuleDetails(moduleId);
    }
  }, [moduleId]);

  return {
    moduleDetails: modulesStore.moduleDetails
  };
};
